import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface MobileMetric {
  label: string;
  value: string | number;
  warning?: boolean;
}

@Component({
  selector: 'app-mobile-metric-ribbon',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './mobile-metric-ribbon.component.html',
  styleUrls: ['./mobile-metric-ribbon.component.css']
})
export class MobileMetricRibbonComponent {
  @Input() metrics: MobileMetric[] = [];
}
